var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenmaxLab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 47,
    viewBox: "0 0 271 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1524_13694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.742 11.8193V34.7204L37.369 36.0806L35.3207 37.2677L32.9726 38.6279L30.8993 39.8398L28.5513 41.2L26.503 42.3871L24.13 43.772L22.0817 44.9591L19.7086 46.3193L17.6603 45.1322L15.3373 43.772L13.239 42.5602L10.9409 41.2247L8.81768 40.0129V16.9634L11.0658 15.6774L13.239 14.3914L15.4871 13.1054L17.6603 11.8441L19.8835 10.5333L22.0817 9.27202L24.3048 7.986L22.0817 6.67525L19.9085 5.43869L17.6603 6.74944L15.4871 7.986L13.239 9.29676L11.0908 10.558L8.81768 11.8688L6.66946 13.1054L4.42133 14.4161V37.4408L2.14822 36.1301L0 34.8688V11.8935L2.27311 10.558L4.42133 9.32149L6.69444 8.01073L8.81768 6.77417L11.1158 5.43869L13.239 4.20213L15.5121 2.89138L17.6603 1.63009L19.9334 0.319336L22.0817 1.5559L24.3298 2.86665L26.503 4.12794L28.7261 5.41396L30.8993 6.67525L33.1225 7.96127L30.8993 9.24729L28.7012 10.5333L26.503 11.8193L24.2798 13.0806L22.0817 14.3666L19.8585 15.6527L17.6603 16.9387L15.4372 18.2247L13.239 19.486V37.4408L15.3622 38.6527L17.6603 40.0129L19.7336 41.2L22.0817 39.8645L24.1549 38.6527L26.503 37.2925L28.5763 36.0806L30.8993 34.7451L32.9976 33.5333L35.3207 32.1731V16.8892L33.0725 18.2H33.0476L30.8993 19.4365L28.6512 20.7473L26.503 22.0086L24.2299 23.3193L22.0817 24.5559V29.6505L24.2049 28.4387L26.503 27.1032L28.6262 25.8666L30.8993 24.5312V29.6505L28.6013 30.986L26.503 32.1978L24.1799 33.5333L22.0817 34.7699L19.7586 36.1054L17.6603 34.8688V22.0333L19.8335 20.772L22.0817 19.4613L24.2549 18.2L26.503 16.914L28.6762 15.6527L30.8993 14.3419L33.0975 13.0806L35.3207 11.7946L37.4939 10.5086L39.742 11.8193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5562 35.3385V11.2998H70.6411V16.8149H58.6011V29.8482H64.6211V25.8912H70.6411V35.3138H52.5562V35.3385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1372 35.3385V11.2998H93.1473V16.8149H81.1572V20.5987H93.1473V25.8912H81.1572V29.8482H93.1473V35.3138H75.1372V35.3385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.309 35.3387V16.8398H103.289V35.3387H98.4431V16.8398H97.2441V11.3247H115.329V35.3387H109.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.486 35.3387V16.8398H134.488V35.3387H128.468V16.8398H125.471V35.3387H120.625V16.8398H119.426V11.3247H143.506V35.3387H137.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.067 35.3385V28.6364H154.047V35.3385H148.027V11.2998H166.112V35.3138H160.092L160.067 35.3385ZM160.067 16.8149H154.047V23.146H160.067V16.8149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.448 35.3387V25.9161H176.428V35.3387H170.408V25.9161L173.081 23.2946L170.408 20.6236V11.3247H176.428V20.6236H182.448V11.3247H188.468V20.6236L185.795 23.2946L188.468 25.9161V35.3387H182.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.027 35.3385V11.2998H214.047V29.8482H226.037V35.3138H208.027V35.3385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.373 35.3385V28.6364H236.353V35.3385H230.333V11.2998H248.418V35.3138H242.398L242.373 35.3385ZM242.373 16.8149H236.353V23.146H242.373V16.8149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.915 35.3385V11.2998H271V20.5987L268.327 23.2697L271 25.8912V35.3138H252.915V35.3385ZM264.98 16.8149H258.96V20.5987H264.98V16.8149ZM264.98 25.8912H258.96V29.8482H264.98V25.8912Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1524_13694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 271,
    height: 46,
    fill: "white",
    transform: "translate(0 0.319336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenmaxLab);
export default __webpack_public_path__ + "static/media/genmax_lab.e456bb45ca77573844a43cf3961e9134.svg";
export { ForwardRef as ReactComponent };